<template>
    <div class="story flex h-full flex-col overflow-hidden rounded-3xl">
        <slot name="default" :story="story">
            <NuxtImg
                format="webp"
                quality="80"
                placeholder
                loading="lazy"
                width="338"
                height="338"
                :src="$image(story.image)"
                :alt="story.alt"
                class="aspect-square w-full object-cover shrink-0"
            />

            <div class="story-info flex flex-1 flex-col justify-between items-start gap-6 p-6 bg-white related-resource-description">
                <span v-html="story.description" />
                <NuxtLink
                    v-if="linkDestination"
                    :to="linkDestination"
                    class="group btn md font-manrope text-base l-h-20 f-w-700 l-t-s-3 inline-flex justify-start plain mt-8 text-start p-0 w-fit"
                >
                    <span class="font-manrope text-sm font-bold leading-4 tracking-[-0.3px] text-black transition-colors duration-300 group-hover:text-primary-500">
                        {{ linkText }}
                    </span>
                    <UIcon
                        name="i-lucide-arrow-right"
                        class="size-5 ml-1 text-black transition-colors duration-300 group-hover:text-primary-500"
                    />
                </NuxtLink>
            </div>
        </slot>
    </div>
</template>

<script setup lang="ts">
import type { CustomerStory } from '~/types/customer-story'

const props = withDefaults(defineProps<{
    defaultLink?: string
    linkText?: string
    onlyUseExplicitUri?: boolean
    showLink?: boolean
    story?: CustomerStory
}>(), {
    defaultLink: '/case-studies',
    linkText: 'Read their story',
    onlyUseExplicitUri: false,
    showLink: true,
    story: () => ({}),
})

const linkDestination = computed((): string | null => {
    if (!props.showLink) return null
    const uri = typeof props.story.uri === 'string' ? props.story.uri.trim() : ''
    const hasExplicit = Boolean(uri && uri !== '/')
    if (props.onlyUseExplicitUri) return hasExplicit ? uri : null
    if (hasExplicit) return uri
    return props.defaultLink || null
})
</script>

<style scoped>
:deep(.related-resource-description a) {
    color: inherit;
    text-decoration: none;
}

:deep(.related-resource-description a:hover) {
    text-decoration: underline;
}
</style>
